/**
 * @generated SignedSource<<9e05100ef56fd3976d5640817d1d4226>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ConnectionStatus = "OFFLINE" | "ONLINE" | "%future added value";
export type Priority = "HIGH" | "HIGHEST" | "LOW" | "MEDIUM" | "%future added value";
export type SanitizerLevelStatus = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type ServiceType = "ON_SITE" | "REMOTE" | "%future added value";
export type StaffEnthusiasm = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type Statuses = "ARCHIVED" | "COMPLETED" | "IN_PROCESS" | "ON_HOLD" | "PENDING" | "%future added value";
export type TicketType = "LAB" | "MARKETING_OTHER" | "PREVENTIVE_MAINTANANCE" | "REACTIVE_MAINTANANCE" | "%future added value";
export type TrafficRate = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type MachineHistory_getmachineQuery$variables = {
  id: string;
};
export type MachineHistory_getmachineQuery$data = {
  readonly getmachine: {
    readonly blender: {
      readonly id: string;
      readonly title: string;
      readonly versionNo: string;
    } | null;
    readonly blenderId: string | null;
    readonly board: {
      readonly id: string;
      readonly title: string;
      readonly versionNo: string;
    } | null;
    readonly boardId: string | null;
    readonly connectionStatus: ConnectionStatus | null;
    readonly createdAt: any | null;
    readonly createdBy: {
      readonly firstName: string;
      readonly id: string;
    } | null;
    readonly createdById: string | null;
    readonly cupHolder: {
      readonly id: string;
      readonly title: string;
    } | null;
    readonly cupHolderId: string | null;
    readonly deployingPerson: {
      readonly firstName: string;
      readonly id: string;
    } | null;
    readonly deployingPersonId: string | null;
    readonly deploymentDate: string;
    readonly hardwareVersion: string | null;
    readonly id: string;
    readonly isActive: boolean;
    readonly isPilot: boolean;
    readonly isPolyfuses: boolean | null;
    readonly isRetired: boolean;
    readonly lastFilterReplacedAt: any | null;
    readonly lastHearbeatSyncAt: any | null;
    readonly lastSanitizeTime: any | null;
    readonly lastSanitizerReplacedAt: any | null;
    readonly location: {
      readonly address: string;
      readonly contactName: string | null;
      readonly contactPhone: string | null;
      readonly createdAt: any | null;
      readonly createdById: string | null;
      readonly customerId: string;
      readonly deploymentManagerId: string | null;
      readonly distributorId: string | null;
      readonly id: string;
      readonly isActive: boolean;
      readonly launchDate: string | null;
      readonly locationTypeId: string | null;
      readonly marketSegmentId: string | null;
      readonly name: string;
      readonly regionId: string | null;
      readonly targetLaunchDate: string | null;
      readonly uuid: string | null;
    } | null;
    readonly locationHistory: ReadonlyArray<{
      readonly createdAt: any;
      readonly id: string;
      readonly isAssign: boolean;
      readonly location: {
        readonly address: string;
        readonly city: string | null;
        readonly createdAt: any | null;
        readonly deploymentManager: {
          readonly firstName: string;
          readonly id: string;
          readonly lastName: string | null;
        } | null;
        readonly distributor: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly id: string;
        readonly isActive: boolean;
        readonly launchDate: string | null;
        readonly locationType: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly marketSegment: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly name: string;
        readonly region: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly targetLaunchDate: string | null;
        readonly uuid: string | null;
      } | null;
      readonly locationId: string;
      readonly machineId: string;
      readonly updatedAt: any;
    }> | null;
    readonly locationId: string | null;
    readonly macAddress: string | null;
    readonly machineStatus: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly machineStatusId: string | null;
    readonly metas: ReadonlyArray<{
      readonly createdAt: any;
      readonly metaKey: string;
      readonly metaValue: string;
      readonly updatedAt: any;
    }> | null;
    readonly name: string | null;
    readonly noteRelatedToMechanicalHardwareVersion: string | null;
    readonly remark: string | null;
    readonly retiredAt: any | null;
    readonly retiredBy: {
      readonly email: string;
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string | null;
    } | null;
    readonly retiredById: string | null;
    readonly sanitizerLevel: SanitizerLevelStatus | null;
    readonly serialNumber: string;
    readonly softwareVersion: string | null;
    readonly tickets: ReadonlyArray<{
      readonly assignTo: {
        readonly firstName: string;
        readonly id: string;
      } | null;
      readonly closingDateAndTime: string | null;
      readonly comment: string | null;
      readonly createdBy: {
        readonly firstName: string;
        readonly id: string;
      } | null;
      readonly id: string;
      readonly machine: {
        readonly id: string;
        readonly name: string | null;
      } | null;
      readonly priority: Priority;
      readonly reportedAt: string | null;
      readonly serviceType: ServiceType | null;
      readonly staffEnthusiasm: StaffEnthusiasm | null;
      readonly status: Statuses;
      readonly ticketSource: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly ticketType: TicketType | null;
      readonly timeSpentOnTask: number | null;
      readonly trafficRate: TrafficRate | null;
      readonly travelTime: string | null;
      readonly uuid: string | null;
    }> | null;
    readonly trialEndDate: string | null;
    readonly tubeShield: {
      readonly description: string | null;
      readonly id: string;
      readonly name: string;
    } | null;
    readonly tubeShieldId: string | null;
    readonly updatedAt: any | null;
    readonly updatedBy: {
      readonly firstName: string;
      readonly id: string;
    } | null;
    readonly updatedById: string | null;
    readonly uuid: string | null;
  };
};
export type MachineHistory_getmachineQuery = {
  response: MachineHistory_getmachineQuery$data;
  variables: MachineHistory_getmachineQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationId",
  "storageKey": null
},
v5 = [
  (v1/*: any*/),
  (v3/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdById",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v11 = [
  (v1/*: any*/),
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "UserObjectType",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetLaunchDate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "launchDate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v17 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "versionNo",
    "storageKey": null
  },
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v19 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "MachineObjectType",
    "kind": "LinkedField",
    "name": "getmachine",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serialNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sanitizerLevel",
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "macAddress",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deploymentDate",
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deployingPersonId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "machineStatusId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MachineStatusObjectType",
        "kind": "LinkedField",
        "name": "machineStatus",
        "plural": false,
        "selections": (v5/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "softwareVersion",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hardwareVersion",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "connectionStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastHearbeatSyncAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastSanitizeTime",
        "storageKey": null
      },
      (v6/*: any*/),
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedById",
        "storageKey": null
      },
      (v8/*: any*/),
      (v9/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isPilot",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isPolyfuses",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tubeShieldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "trialEndDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastSanitizerReplacedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastFilterReplacedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "remark",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "noteRelatedToMechanicalHardwareVersion",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "retiredAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "blenderId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "boardId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cupHolderId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "retiredById",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isRetired",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MachineMetaObjectType",
        "kind": "LinkedField",
        "name": "metas",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metaKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metaValue",
            "storageKey": null
          },
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TubeShieldObjectType",
        "kind": "LinkedField",
        "name": "tubeShield",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "UserObjectType",
        "kind": "LinkedField",
        "name": "updatedBy",
        "plural": false,
        "selections": (v11/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserObjectType",
        "kind": "LinkedField",
        "name": "deployingPerson",
        "plural": false,
        "selections": (v11/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LocationObjectType",
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerId",
            "storageKey": null
          },
          (v3/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "regionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactPhone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "marketSegmentId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deploymentManagerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locationTypeId",
            "storageKey": null
          },
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "distributorId",
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BlenderObjectType",
        "kind": "LinkedField",
        "name": "blender",
        "plural": false,
        "selections": (v17/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BoardObjectType",
        "kind": "LinkedField",
        "name": "board",
        "plural": false,
        "selections": (v17/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CupHolderObjectType",
        "kind": "LinkedField",
        "name": "cupHolder",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v16/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserObjectType",
        "kind": "LinkedField",
        "name": "retiredBy",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v10/*: any*/),
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TicketObjectType",
        "kind": "LinkedField",
        "name": "tickets",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MachineObjectType",
            "kind": "LinkedField",
            "name": "machine",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ticketType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "comment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priority",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TicketSourceObjectType",
            "kind": "LinkedField",
            "name": "ticketSource",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reportedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "closingDateAndTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserObjectType",
            "kind": "LinkedField",
            "name": "assignTo",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "travelTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "trafficRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeSpentOnTask",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "staffEnthusiasm",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MachineLocationHistoryObjectType",
        "kind": "LinkedField",
        "name": "locationHistory",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "machineId",
            "storageKey": null
          },
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAssign",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LocationObjectType",
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v3/*: any*/),
              (v2/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketSegmentObjectType",
                "kind": "LinkedField",
                "name": "marketSegment",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserObjectType",
                "kind": "LinkedField",
                "name": "deploymentManager",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v10/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LocationTypeObjectType",
                "kind": "LinkedField",
                "name": "locationType",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RegionObjectType",
                "kind": "LinkedField",
                "name": "region",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DistributorObjectType",
                "kind": "LinkedField",
                "name": "distributor",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              (v14/*: any*/),
              (v15/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MachineHistory_getmachineQuery",
    "selections": (v19/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MachineHistory_getmachineQuery",
    "selections": (v19/*: any*/)
  },
  "params": {
    "cacheID": "f1f460854ee3019aab56d3c31c6f01fb",
    "id": null,
    "metadata": {},
    "name": "MachineHistory_getmachineQuery",
    "operationKind": "query",
    "text": "query MachineHistory_getmachineQuery(\n  $id: String!\n) {\n  getmachine(id: $id) {\n    id\n    uuid\n    serialNumber\n    sanitizerLevel\n    name\n    macAddress\n    deploymentDate\n    locationId\n    deployingPersonId\n    machineStatusId\n    machineStatus {\n      id\n      name\n    }\n    softwareVersion\n    hardwareVersion\n    connectionStatus\n    lastHearbeatSyncAt\n    lastSanitizeTime\n    createdById\n    createdAt\n    updatedById\n    updatedAt\n    isActive\n    isPilot\n    isPolyfuses\n    tubeShieldId\n    trialEndDate\n    lastSanitizerReplacedAt\n    lastFilterReplacedAt\n    remark\n    noteRelatedToMechanicalHardwareVersion\n    retiredAt\n    blenderId\n    boardId\n    cupHolderId\n    retiredById\n    isRetired\n    metas {\n      metaKey\n      metaValue\n      createdAt\n      updatedAt\n    }\n    tubeShield {\n      id\n      name\n      description\n    }\n    createdBy {\n      id\n      firstName\n    }\n    updatedBy {\n      id\n      firstName\n    }\n    deployingPerson {\n      id\n      firstName\n    }\n    location {\n      id\n      uuid\n      customerId\n      name\n      address\n      regionId\n      contactName\n      contactPhone\n      marketSegmentId\n      deploymentManagerId\n      locationTypeId\n      targetLaunchDate\n      launchDate\n      distributorId\n      createdById\n      createdAt\n      isActive\n    }\n    blender {\n      id\n      versionNo\n      title\n    }\n    board {\n      id\n      versionNo\n      title\n    }\n    cupHolder {\n      id\n      title\n    }\n    retiredBy {\n      id\n      firstName\n      lastName\n      email\n    }\n    tickets {\n      id\n      uuid\n      machine {\n        id\n        name\n      }\n      ticketType\n      serviceType\n      comment\n      priority\n      ticketSource {\n        id\n        name\n      }\n      createdBy {\n        id\n        firstName\n      }\n      reportedAt\n      closingDateAndTime\n      assignTo {\n        id\n        firstName\n      }\n      travelTime\n      trafficRate\n      timeSpentOnTask\n      status\n      staffEnthusiasm\n    }\n    locationHistory {\n      id\n      locationId\n      machineId\n      createdAt\n      updatedAt\n      isAssign\n      location {\n        id\n        name\n        uuid\n        address\n        city\n        isActive\n        marketSegment {\n          id\n          name\n        }\n        deploymentManager {\n          id\n          firstName\n          lastName\n        }\n        locationType {\n          id\n          name\n        }\n        region {\n          id\n          name\n        }\n        distributor {\n          id\n          name\n        }\n        targetLaunchDate\n        launchDate\n        createdAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "685a153bd3de41f8503ce99c65d1bc82";

export default node;
